let okeResponse = require('okeoke.standardresponse')
let moment = require('moment')
let { UUID } = require("uuidjs")
import { storeDocument, getDocumentDB, getShiftDocumentsDB, getUnsyncedDocuments, cleanupDocuments, getRefDocumentsDB } from '../../IDB/documents'
import { DocumentTypes } from '../../consts'
import ordereduuid from '../../Helpers/timeuuid'
import merge from 'lodash.merge'

let Documents = function (clientSocket, client) {
  const uid = UUID.generate()

  async function getOnlineShiftDocuments(shiftUUID) {
    return new Promise((resolve, reject) => {
      if (clientSocket.authorized) {
        setTimeout(() => {
          resolve({ success: false, message: 'Timeout!', code: 408, data: { errMsgCode: 'request.error.timeout' } })
        }, 5000)
        clientSocket.ioclient.emit('getShiftDocuments', { shiftUUID }, (e) => {
          resolve(e)
        })
      } else {
        resolve({ success: false, message: 'No connection to server!' })
      }
    })
  }

  async function syncDocument(document) {
    return new Promise((resolve, reject) => {
      if (!clientSocket.authorized) {
        document.syncneeded = 1
        //console.log('NOT CONNECTED', document.uuid, document.syncneeded)
        storeDocument(document).then(() => {
          resolve({ success: false, message: 'Client not connected!' })
        })
      } else {
        let done = false
        setTimeout(() => {
          if (!done) {
            document.syncneeded = 1
            //console.log('TIMEOUT', document.uuid, document.syncneeded)
            storeDocument(document).then(() => {
              resolve({ success: false, message: 'Timeout!', code: 408, data: { errMsgCode: 'request.error.timeout' } })
            })
          }
        }, 5000)
        clientSocket.ioclient.emit(
          'syncDocument',
          {
            document
          },
          (e) => {
            //console.log('syncDocument', e)
            done = true
            if (!e.success) {
              document.syncneeded = 1
              //console.log('UNSUCCESSFUL', document.uuid, document.syncneeded)
              storeDocument(document).then(() => {
                resolve(e)
              })
            } else {
              document.syncneeded = 0
              //console.log('SUCCESSFUL', document.uuid, document.syncneeded)
              storeDocument(document).then(() => {
                resolve(e)
              })
            }
          }
        )
      }
    })
  }

  async function getOnlineDocument(documentUUID) {
    return new Promise((resolve, reject) => {
      if (clientSocket.authorized) {
        setTimeout(() => {
          resolve({ success: false, message: 'Timeout!', code: 408, data: { errMsgCode: 'request.error.timeout' } })
        }, 5000)
        clientSocket.ioclient.emit('getDocument', { documentUUID }, (e) => {
          resolve(e)
        })
      } else {
        resolve({ success: false, message: 'No connection to server!' })
      }
    })
  }

  function sumItems(items) {
    let totalSum = 0
    let discountedSum = 0
    for (let item of items) {
      let itemPrice = +(item.price || 0)
      let itemDiscountPrice = +(item.discountPrice == null ? itemPrice : item.discountPrice)
      totalSum += Math.round(itemPrice * item.count)
      discountedSum += Math.round(itemDiscountPrice * item.count)
    }
    discountedSum = Math.round(discountedSum)
    totalSum = Math.round(totalSum)
    return { totalSum, discountedSum }
  }

  function sumPayments(transactions) {
    let totalSum = 0
    let errors = []
    for (let transaction of transactions) {
      if (transaction.agentType == 'cash') {
        if (transaction.amount % 5 != 0) {
          transaction.amount = Math.round(transaction.amount / 5) * 5
        }
      }
      totalSum += transaction.amount
    }
    return { totalSum, errors }
  }

  async function addDocument(shiftUUID, documentType, documentSubType, documentExtID, documentExtSuccess, items = [], transactions = [], reasonID = 0, fiscalReceipt = null, refDocumentUUID = null, invoice = null, onlineInvoice = false, data) {
    //if (!client.localUser?.userUUID) return okeResponse(false, 400, 'No user logged in', null)
    if (!client.tokenData?.deviceUUID) return okeResponse(false, 400, 'No device inited', { errMsgCode: 'add.document.device.notinited' })
    let { totalSum: totalTransactions, errors } = sumPayments(transactions)
    if (errors?.length > 0) return okeResponse(false, 400, 'Invalid transactions', { errors })
    if ([DocumentTypes.Receipt].includes(documentType)) {
      let { discountedSum } = sumItems(items)
      let sumDiff = discountedSum - totalTransactions
      //console.log({ discountedSum, totalTransactions, sumDiff })
      if (Math.abs(sumDiff) > 2) return okeResponse(false, 400, 'Transaction sum does not match items sum', { errMsgCode: 'add.document.transactions.items.mismatch' })
    }
    if ([DocumentTypes.ReceiptStorno].includes(documentType) && documentExtID) {
      let originalDocument = await getDocument(documentExtID)
      if (!originalDocument.success) return okeResponse(false, 400, 'Original document not found', { errMsgCode: 'add.document.original.notfound' })
      if (originalDocument.data.documentType !== DocumentTypes.Receipt) return okeResponse(false, 400, 'Original document is not a receipt', { errMsgCode: 'add.document.original.notreceipt' })
    }
    let documentUUID = ordereduuid()
    let newDocument = {
      uuid: documentUUID,
      refDocumentUUID,
      deviceUUID: client.tokenData?.deviceUUID,
      shiftUUID: shiftUUID,
      documentType,
      documentSubType,
      documentExtID,
      documentExtSuccess,
      reasonID,
      fiscalReceipt,
      invoice,
      onlineInvoice,
      sysUserUUID: client.localUser?.userUUID || null,
      createTimestamp: new Date().getTime(),
      syncneeded: 1
    }
    if (items?.length > 0) {
      for await (let item of items) {
        let itemPrice = item.price || 0
        let itemDiscountPrice = item.discountPrice == null ? itemPrice : item.discountPrice
        await client.items.addItem(shiftUUID, documentUUID, item.name || 'N/A',
          [DocumentTypes.PayOut, DocumentTypes.ReceiptStorno].includes(documentType) ? -item.count : item.count,
          item.quantity, item.unitType || 'piece',
          itemPrice, itemDiscountPrice, item.type, item.subType || null,
          +item.vat, item.vatLetter || 'C', item.vatRegister || '00', item.notes || null, 
          item.data || null, item.refItemUUID || null, item.itemSizeUUID)
      }
    }
    if (transactions?.length > 0) {
      for await (let transaction of transactions) {
        let trxAmount = Math.abs(transaction.amount)
        if ([DocumentTypes.PayOut, DocumentTypes.ReceiptStorno].includes(documentType)) {
          trxAmount = -trxAmount
        }
        await client.transactions.addTransaction(shiftUUID, documentUUID, trxAmount, transaction.agentID || 0, transaction.agentType,
          transaction.agentSubType, transaction.extTransactionID
        )
      }
    }
    if (data?.length > 0) {
      for await (let _dat of data) {
        await client.documentData.addData(shiftUUID, documentUUID, _dat.dataType, _dat.data)
      }
    }
    await storeDocument(newDocument)
    await syncDocument(newDocument)
    return okeResponse(true, 201, 'Inserted', { ...newDocument })
  }

  async function updateDocument(document) {
    let existing = await getDocument(document.uuid)
    //console.log({existing})
    if (!existing.success) return okeResponse(false, 404, 'Not found', { errMsgCode: 'update.document.notfound' })
    let updated = merge(existing.data, document)
    updated.syncneeded = 1
    await syncDocument(updated)
    return existing
  }

  async function syncOnlineDocuments(shiftUUID) {
    let onlineRes = await getOnlineShiftDocuments(shiftUUID)
    if (onlineRes.success) {
      for await (let doc of onlineRes.data) {
        //console.log('SYNCING ONLINE DOCUMENT', doc)
        let existing = await getDocumentDB(doc.uuid)
        if (!existing) {
          await storeDocument(doc)
        }
        for await (let item of doc.items || []) {
          let existingItem = await client.items.getItem(item.uuid)
          if (!existingItem.success) {
            await client.items.storeItem(item)
          }
        }
        for await (let transaction of doc.transactions || []) {
          let existingTransaction = await client.transactions.getTransaction(transaction.uuid)
          if (!existingTransaction.success) {
            await client.transactions.storeTransaction(transaction)
          }
        }
        for await (let _data of doc.data || []) {
          let existingData = await client.documentData.getData(_data.uuid)
          if (!existingData.success) {
            await client.documentData.storeData(_data)
          }
        }
      }
    }
  }

  async function syncOffline() {
    let documents = await getUnsyncedDocuments()
    for await (let doc of documents) {
      await syncDocument(doc)
    }
    //console.log('CLIENT.SHIFT:', client?.shifts?.currentShift)
    if (client.shift?.uuid) {
      await syncOnlineDocuments(client.shift?.uuid)
    }
  }

  function onShiftsInited(shift) {
    //console.log('onShiftsInited', shift)
    if (shift?.uuid) {
      syncOnlineDocuments(shift?.uuid)
    }
  }

  function onConnectionChange(data) {
    switch (data.state) {
      case 'Authorized':
        syncOffline()
        break
      default:
        break
    }
  }

  async function onDocumentUpdated(data) {
    //console.log('onDocumentUpdated', data)
    if (data?.document?.uuid) {
      await storeDocument(data.document)
    }
  }

  async function init(shift) {
    if (!client.offlineEnabled) return
    let connected = clientSocket.authorized
    onShiftsInited(shift)
    clientSocket.addCallback('onConnectionChange', uid, onConnectionChange)
    clientSocket.addCallback('onDocumentUpdated', uid, onDocumentUpdated)
    //console.log({shift})
    await cleanupDocuments(shift?.uuid && shift.shiftEnd == null ? shift.uuid : null)
    if (connected) syncOffline()
  }

  async function getShiftDocuments(shiftUUID) {
    let documents = await getShiftDocumentsDB(shiftUUID)
    if (!documents) return okeResponse(false, 500, 'Not found', { errMsgCode: 'shift.documents.get.error' })
    for await (let document of documents) {
      let documentRes = await getDocument(document.uuid)
      if (!documentRes.success) return okeResponse(false, 500, 'Error fetching document', { errMsgCode: 'shift.documents.get.error.content' })
      document.transactions = documentRes.data.transactions
      document.items = documentRes.data.items
      document.transactionsSum = documentRes.data.transactionsSum
      document.itemsSum = documentRes.data.itemsSum
      document.refDocuments = documentRes.data.refDocuments
      document.data = documentRes.data.data
    }
    return okeResponse(true, 200, 'Success', documents)
  }

  async function getOnlineDocument(documentUUID) {
    return new Promise((resolve, reject) => {
      if (clientSocket.authorized) {
        setTimeout(() => {
          resolve({ success: false, message: 'Timeout!', code: 408, data: { errMsgCode: 'request.error.timeout' } })
        }, 5000)
        clientSocket.ioclient.emit('getDocument', { documentUUID }, (e) => {
          //console.log('getOnlineDocument - ONLINE', e)
          resolve(e)
        })
      } else {
        resolve({ success: false, message: 'No connection to server!' })
      }
    })
  }

  async function getDocumentItemsAndTransactions(documentUUID) {
    let documentTransactions = await client.transactions.getDocumentTransactions(documentUUID)
    let documentItems = await client.items.getDocumentItems(documentUUID)
    let documentData = await client.documentData.getDocumentDatas(documentUUID)
    if (!documentTransactions.success || !documentItems.success) return okeResponse(false, 500, 'Error fetching document transactions or items', { errMsgCode: 'shift.documents.get.error.content' })
    let transactionsSum = 0
    for (let transaction of documentTransactions.data) {
      transactionsSum += +transaction.amount
    }
    let itemsSum = 0
    let itemsDiscountedSum = 0
    for (let item of documentItems.data) {
      itemsSum += Math.round(+item.price * +item.count)
      itemsDiscountedSum += Math.round(+item.discountPrice * +item.count)
    }
    let refDocuments = await getRefDocumentsDB(documentUUID)
    if (refDocuments?.length > 0) {
      for await (let refDocument of refDocuments) {
        let docDetails = await getDocumentItemsAndTransactions(refDocument.uuid)
        if (docDetails.success) {
          refDocument.transactions = docDetails.data.transactions
          refDocument.items = docDetails.data.items
          refDocument.transactionsSum = docDetails.data.transactionsSum
          refDocument.itemsSum = docDetails.data.itemsSum
          refDocument.itemsDiscountedSum = docDetails.data.itemsDiscountedSum
          transactionsSum += docDetails.data.transactionsSum
          itemsSum += docDetails.data.itemsSum
          refDocument.data = docDetails.data.data
        }
      }
    }
    return okeResponse(true, 200, 'Success', { transactions: documentTransactions.data, items: documentItems.data, data:documentData.data, transactionsSum, itemsSum, itemsDiscountedSum, refDocuments })
  }

  async function getDocument(uuid) {
    if (typeof uuid !== 'string') return okeResponse(false, 400, 'Invalid uuid', { errMsgCode: 'update.document.invaliduuid' })
    let document = await getDocumentDB(uuid.toUpperCase())
    if (!document) {
      let onlineDocument = await getOnlineDocument(uuid)
      if (onlineDocument.success) {
        document = onlineDocument.data
        // Store document so that we can update it later if needed.
        await storeDocument(document)
        for (let item of document.items || []) {
          let existingItem = await client.items.getItem(item.uuid)
          if (!existingItem.success) {
            await client.items.storeItem(item)
          }
        }
        for (let transaction of document.transactions || []) {
          let existingTransaction = await client.transactions.getTransaction(transaction.uuid)
          if (!existingTransaction.success) {
            await client.transactions.storeTransaction(transaction)
          }
        }
        for await(let refDocument of document.refDocuments || []) {
          let existingDocument = await getDocument(refDocument.uuid)
          if(!existingDocument.success) return existingDocument
        }
      } else {
        return okeResponse(false, 404, 'Not found', { errMsgCode: 'update.document.notfound' })
      }
    }
    let docDetails = await getDocumentItemsAndTransactions(document.uuid)
    if (docDetails.success) {
      document.transactions = docDetails.data.transactions
      document.items = docDetails.data.items
      document.transactionsSum = docDetails.data.transactionsSum
      document.itemsSum = docDetails.data.itemsSum
      document.refDocuments = docDetails.data.refDocuments
      document.data = docDetails.data.data
    }
    return okeResponse(true, 200, 'Success', document)
  }

  return {
    init,
    addDocument,
    updateDocument,
    getShiftDocuments,
    getDocument
  }
}

export { Documents }